import { Component, OnInit } from '@angular/core';

/**
 * 登录页
 *
 * @version 1.0
 * @since 1.0
 */
@Component({
  selector: 'fl-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss'],
  standalone: false,
})
export class LoginPageComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
